/**
 * Enum for Feature Flag Ids
 * see this link for more info https://sprouthq.atlassian.net/l/cp/mh1twVAx
 * @readonly
 * @enum {name: {value: number}}
 */
export const FeatureFlagIdEnum = Object.freeze({
  azureAttendanceReport: 1,
  preComputedAttendance: 2,
  loans: 3,
  forceComputation: 4,
  dateTagging: 5,
  newCarryOver: 6,
  zendeskSupport: 7,
  leaveReportOptimization: 8,
  prepaidHmo: 9,
  mobileAppV2: 10,
  mobileDeviceRegistration: 11,
  mobileDeviceJailBrokenValidation: 12,
  loansIFrameHidden: 13,
  loansIFrameVisible: 14,
  authenticationModule: 15,
  temperatureMonitoring: 16,
  multiServerDatabase: 17,
  dtsCompressed: 18,
  allowWebServiceIntegration: 19,
  instaCashMobile: 20,
  dailyPulse: 21,
  hrPerfProSso: 22,
  changeTemporaryPassword: 23,
  saveAttendanceReportToCache: 24,
  performanceProEmployeeSync: 25,
  nextDayRdComputation: 26,
  leavesForMobile: 27,
  officialBusinessForMobile: 28,
  overtimeForMobile: 29,
  undertimeForMobile: 30,
  scheduleAdjustmentForMobile: 31,
  certificateOfAttendanceForMobile: 32,
  announcementModule: 33,
  futureDatedResignation: 34,
  notificationEngine: 35,
  projectTagging: 36,
  jobRequestModule: 37,
  dailyPulseClockIn: 38,
  dailyPulseClockOut: 39,
  payrollSalaryHistory: 40,
  attendanceManager: 41,
  new201: 42,
  loginAdsDisable: 43,
  enableFintechNav: 44,
  breakMonitoringWidget: 45,
  futureDatedResignationApi: 46,
  enableIndependent201Configuration: 47,
  enableChangeLanguage: 49,
  dtsEmployeeScheduleGet: 50,
  employeeSyncHrAndPayrollApi: 51,
  dateTaggingEmployeeScheduleGetPhase2: 52,
  dateTaggingEmployeeScheduleAdjustmentGet: 53,
  mobileBundy: 54,
  useApiApprovalActions: 55,
  pushNotification: 56,
  enableSSO: 57,
  bulkUtilityFeature: 58,
  enableAiahChatBotForMobile: 59,
  breakMonitoringAttendanceReport: 60,
  enableMobileOtpGenerator: 61,
  leaveCreditsOptimization: 62,
  enableSsoForMobile: 63,
  disableChatbotWidget: 64,
  enableAccountLocked: 65,
  disableNewAccountEmailNotification: 66,
  ecosystemDashboardEnabled: 67,
  maintenanceModule201: 68,
  enable201Syncing: 69,
  enableEditNewFields: 70,
  enableReadyWageMobile: 71,
  enableReadyWageWeb: 72,
  featureManagementPage: 73,
  enableWorkLocationModule: 74,
  enableEditEhubField: 75,
  enableOlympus: 80,
  enableCustomFields: 83,
  enableFatureManagementCompanyPolicy: 84,
  enableMultiLingualTranslation: 87,
  hideUnused201Fields: 89,
  enablePayrollInfoSection: 90,
  enableShiftCenterFlexibledBreaks: 92,
  enableShiftCenterFlexibleScheduleBreaks: 93,
  enableShiftCenterAddTimeBlock: 94,
  addEmployeeOlympus: 96,
  enableBulkImportPage: 101,
});
